import { useDispatch, useSelector } from "react-redux";
import { axiosInstance } from "../auth";

export const SET = "gallerySet";
export const SET_LOADING = "galleryLoading";
export const CLEAR = "galleryClear";

export const useGallery = () => {
  const gallery = useSelector((state) => state.gallery);
  const dispatch = useDispatch();
  return {
    ...gallery,
    dispatch,
    getList,
    submittAddFile,
    getCollections,
    submittDeleteFile,
    toggleGallery,
    getItem,
  };
};

export const getItem = (id, cb) => async (dispatch, getState) => {
  try {
    const result = await axiosInstance.get(`/panel/media/${id}`);
    cb(result.data);
  } catch (e) {}
};

export const toggleGallery = (handleSelectFile) => async (
  dispatch,
  getState
) => {
  try {
    const {
      gallery: { showGallery },
    } = getState();

    dispatch({
      type: SET,
      payload: { handleSelectFile, showGallery: !showGallery },
    });
  } catch (e) {}
};

export const getList = (
  collection = undefined,
  search = undefined,
  page = 1
) => async (dispatch, getState) => {
  try {
    const {
      gallery: { list, current_collection, current_search },
    } = getState();

    dispatch({
      type: SET_LOADING,
      payload: true,
    });
    let url = `/panel/media?page=${page}&&collection_name=${
      collection !== undefined ? collection : current_collection
    }&&search=${search !== undefined ? search : current_search}`;
    const result = await axiosInstance.get(url);
    dispatch({
      type: SET,
      payload: {
        list: page > 1 ? [...list, ...result.data.data] : result.data.data,
        loading: false,
        current_page: result.data.meta.current_page,
        last_page: result.data.meta.last_page,
        per_page: result.data.meta.per_page,
        current_collection:
          collection !== undefined ? collection : current_collection,
        current_search: search !== undefined ? search : current_search,
      },
    });
  } catch (e) {
    dispatch({
      type: SET_LOADING,
      payload: false,
    });
  }
};

export const getCollections = () => async (dispatch) => {
  try {
    dispatch({
      type: SET,
      payload: { collectionLoading: true },
    });
    const result = await axiosInstance.get("/panel/core/media-collections");
    dispatch({
      type: SET,
      payload: { collections: result.data, collectionLoading: false },
    });
  } catch (e) {
    dispatch({
      type: SET,
      payload: { collectionLoading: false },
    });
  }
};

export const submittAddFile = (values, cb) => async (dispatch) => {
  try {
    dispatch({
      type: SET_LOADING,
      payload: true,
    });
    const fd = new FormData();
    fd.append("image", values.image.file);

    if (values.name) {
      fd.append("name", values.name);
    }

    if (values.collection_name) {
      fd.append("collection_name", values.collection_name);
    }

    const result = await axiosInstance.post("/panel/media", fd);
    dispatch({
      type: SET_LOADING,
      payload: false,
    });
    cb();
  } catch (e) {}
};
export const submittDeleteFile = (id, cb) => async (dispatch) => {
  try {
    dispatch({
      type: SET_LOADING,
      payload: true,
    });

    const result = await axiosInstance.delete(`/panel/media/${id}`);
    dispatch({
      type: SET_LOADING,
      payload: false,
    });
    cb();
  } catch (e) {}
};
